import React from "react"
import { useIntl } from "react-intl"
import { useNavigate } from "react-router-dom"

import classNames from "classnames"

import { ICONS } from "@doktor-se/bones-ui"
import { IconButton } from "@doktor-se/bones-ui/dist/web-shared/components"

import { featureFlags } from "config"

import styles from "./ListRow.module.scss"

export interface Column {
  key: string
  content: string | JSX.Element | undefined
}

interface ListRowProps {
  column: Column[]
  onClick?: () => void
  notify?: boolean
  conversationId?: string
}

const ListRow = ({ column, notify = false, onClick, conversationId }: ListRowProps) => {
  const navigate = useNavigate()
  const intl = useIntl()

  return (
    <div className={styles.container}>
      <div
        className={classNames(styles.row, { [styles.notify]: notify, [styles.pointer]: !!onClick })}
        role="button"
        onClick={onClick}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            onClick && onClick()
          }
        }}
        tabIndex={0}>
        {column.map(cell => (
          <div key={cell.key} className={classNames(styles.cell, styles[cell.key])}>
            {cell.content}
          </div>
        ))}
      </div>
      {featureFlags.has("errand_details_view") && conversationId && (
        <IconButton
          onClick={() => navigate(`/view-errand/${conversationId}`)}
          Icon={ICONS.Visibility}
          label={intl.formatMessage({ id: "label.errand.view" })}
        />
      )}
    </div>
  )
}

export default ListRow
